import React, { useState, useCallback } from "react";
import { useQwanta } from "qwanyx";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";

export const Text = ({ onModify, qwantumId}) => {
  // Pull the serialized content from Qwanta, and store a local copy:
  const [savedValue, setSavedValue] = useQwanta(qwantumId);
  const [localValue, setLocalValue] = useState(savedValue || "");

  // Use the localValue when configuring the editor:
  // The key issue - we need to properly initialize Lexical's state
  const initialConfig = {
    namespace: "QwanyxText",
    // Don't parse the JSON here, Lexical expects the string
    editorState: localValue || undefined,
    onError: (error) => console.error(error),
    nodes: [],
  };

  // Called on every Lexical update, but we don't save to Qwanta yet:
  const handleEditorChange = useCallback((editorState) => {
    const json = JSON.stringify(editorState);
    setLocalValue(json);
    if (onModify) {
      onModify(json);
    }
  }, [onModify]);

  // Only when the user "blurs" (clicks away) do we save to Qwanta:
  const handleBlur = useCallback(() => {
    if (localValue !== savedValue) {
      setSavedValue(qwantumId, localValue);
    }
  }, [localValue, savedValue, setSavedValue, qwantumId]);

  return (
    <LexicalComposer initialConfig={initialConfig}>
      {/* OnChangePlugin updates localValue (above) with the latest editor state */}
      <OnChangePlugin onChange={handleEditorChange} />

      <div
        className="body-text"
        // On blur, we commit changes to Qwanta:
        onBlur={handleBlur}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          overflow: "auto",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        }}
      >
        <RichTextPlugin
          contentEditable={
            <ContentEditable
              style={{
                width: "100%",
                height: "100%",
                margin: 0,
                outline: "none",
                border: "none",
                fontSize: "inherit",
                lineHeight: "1.5",
                textAlign: "left",
                //backgroundColor: "lightblue",
              }}
            />
          }
          ErrorBoundary={LexicalErrorBoundary}
        />
        <HistoryPlugin />
      </div>
    </LexicalComposer>
  );
};

export default Text;